import { lazy } from "react";

// Lazy load all page components for better code splitting
const Dashboard = lazy(() => import("../Pages/Dashboard"));
const Posts = lazy(() => import("../Pages/Posts"));
const Announcements = lazy(() => import("../Pages/Announcements"));
const Students = lazy(() => import("../Pages/Students"));
const Kids = lazy(() => import("../Pages/Kids"));
const Memberships = lazy(() => import("../Pages/Memberships"));
const Schedule = lazy(() => import("../Pages/Schedule"));
const Administrators = lazy(() => import("../Pages/Administrators"));
const MembershipTypes = lazy(() => import("../Pages/MembershipTypes"));
const Faq = lazy(() => import("../Pages/Faq"));
const Ranks = lazy(() => import("../Pages/Ranks"));
const Classes = lazy(() => import("../Pages/Classes"));
const Coaches = lazy(() => import("../Pages/Coaches"));
const Suggestions = lazy(() => import("../Pages/Suggestions"));
const Privates = lazy(() => import("../Pages/Privates"));
const Guests = lazy(() => import("../Pages/Guests"));
const GuestDetails = lazy(() => import("../Pages/GuestDetails"));
const StudentDetails = lazy(() => import("../Pages/StudentDetails"));
const WebsiteScheduleImage = lazy(() => import("../Pages/WebsiteScheduleImage"));
const WebsiteHeroImage = lazy(() => import("../Pages/WebsiteHeroImage"));
const WebsiteMemberships = lazy(() => import("../Pages/WebsiteMemberships"));
const WebsiteWaiver = lazy(() => import("../Pages/WebsiteWaiver"));
const WebsiteStory = lazy(() => import("../Pages/WebsiteStory"));
const WebsiteMonaemBejaoui = lazy(() => import("../Pages/WebsiteMonaemBejaoui"));
const WebsiteBlackBelts = lazy(() => import("../Pages/WebsiteBlackBelts"));
const WebsiteKids = lazy(() => import("../Pages/WebsiteKids"));

export const routes = [
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard /> },
  { path: `${process.env.PUBLIC_URL}/classes`, Component: <Classes /> },
  { path: `${process.env.PUBLIC_URL}/posts`, Component: <Posts /> },
  { path: `${process.env.PUBLIC_URL}/announcements`, Component: <Announcements /> },
  { path: `${process.env.PUBLIC_URL}/students`, Component: <Students /> },
  { path: `${process.env.PUBLIC_URL}/students/details/:id`, Component: <StudentDetails /> },
  { path: `${process.env.PUBLIC_URL}/kids`, Component: <Kids /> },
  { path: `${process.env.PUBLIC_URL}/guests`, Component: <Guests /> },
  { path: `${process.env.PUBLIC_URL}/guests/details/:id`, Component: <GuestDetails /> },
  { path: `${process.env.PUBLIC_URL}/memberships`, Component: <Memberships /> },
  { path: `${process.env.PUBLIC_URL}/schedule`, Component: <Schedule /> },
  {
    path: `${process.env.PUBLIC_URL}/administrators`,
    Component: <Administrators />,
  },
  {
    path: `${process.env.PUBLIC_URL}/membership-types`,
    Component: <MembershipTypes />,
  },
  { path: `${process.env.PUBLIC_URL}/faqs`, Component: <Faq /> },
  { path: `${process.env.PUBLIC_URL}/ranks`, Component: <Ranks /> },
  { path: `${process.env.PUBLIC_URL}/coaches`, Component: <Coaches /> },
  { path: `${process.env.PUBLIC_URL}/privates`, Component: <Privates /> },
  { path: `${process.env.PUBLIC_URL}/suggestions`, Component: <Suggestions /> },
  { path: `${process.env.PUBLIC_URL}/website/schedule-image`, Component: <WebsiteScheduleImage /> },
  { path: `${process.env.PUBLIC_URL}/website/hero-image`, Component: <WebsiteHeroImage /> },
  { path: `${process.env.PUBLIC_URL}/website/memberships`, Component: <WebsiteMemberships /> },
  { path: `${process.env.PUBLIC_URL}/website/waiver`, Component: <WebsiteWaiver /> },
  { path: `${process.env.PUBLIC_URL}/website/story`, Component: <WebsiteStory /> },
  { path: `${process.env.PUBLIC_URL}/website/monaem-bejaoui`, Component: <WebsiteMonaemBejaoui /> },
  { path: `${process.env.PUBLIC_URL}/website/black-belts`, Component: <WebsiteBlackBelts /> },
  { path: `${process.env.PUBLIC_URL}/website/kids`, Component: <WebsiteKids /> },
];
